import { armarParametros } from "../helpers/armarParametros";
import { fetchConToken, fetchConTokenFiles } from "../helpers/fetch";

const urlBase = (endpoint) => fetchConToken(`Surge/${endpoint}`)

const SurgeService = {
    //Estados Solicitudes
    getEstadosSolicitudes: () => urlBase("EstadosSolicitudes"),

    //SolicitudesSSS
    nuevaSolicitud: (data) => fetchConToken(`SolicitudesSSS`, data, "POST"),
    getSolicitudes: () => fetchConToken(`SolicitudesSSS`),
    getSolicitudesBySolicitud: (solicitud) => fetchConToken(`SolicitudesSSS/NroSolicitud/${solicitud}`),
    searchSolicitudes: (parameters) => fetchConToken(`SolicitudesSSS/Search${armarParametros(parameters)}`),
    searchSolicitudesConPaginado: (data) => fetchConToken(`SolicitudesSSS/SearchConPaginado`, data, "POST"),
    searchContadorSolicitudes: (parameters) => fetchConToken(`SolicitudesSSS/ContadorSearch${armarParametros(parameters)}`),
    aprobarSolicitud: (data) => fetchConToken(`SolicitudesSSS/Aprobar`, data, "PUT"),
    rechazarSolicitud: (data) => fetchConToken(`SolicitudesSSS/Rechazar`, data, "PUT"),
    notificacionSolicitud: (data) => fetchConToken(`SolicitudesSSS/Notificacion`, data, "PUT"),
    pagarSolicitud: (data) => fetchConToken(`SolicitudesSSS/Pagar`, data, "PUT"),
    devolverUltimoEstadoSolicitud: (data) => fetchConToken(`SolicitudesSSS/DevolverEstado`, data, "PUT"),
    getTrackingSolicitud: (id) => fetchConToken(`SolicitudesSSS/Tracking/${id}`),
    removeSolicitud: (data) => fetchConToken(`SolicitudesSSS`, data, "DELETE"),
    updateSolicitud: (idSolicitud, data) => fetchConToken(`SolicitudesSSS/${idSolicitud}`, data, "PUT"),

    //Conceptos
    getConceptos: () => fetchConToken(`Surge/Conceptos`),
    insertConcepto: (data) => fetchConToken(`Surge/Conceptos`, data, "POST"),
    updateConcepto: (data) => fetchConToken(`Surge/Conceptos`, data, "PUT"),
    removeConcepto: (data) => fetchConToken(`Surge/Conceptos`, data, "DELETE"),

    //Resoluciones
    getResoluciones: () => fetchConToken(`Surge/Resoluciones`),

    //Matriculas
    getMatriculas: () => fetchConToken(`TipoMatriculas`),

    //Practicas Y Dispositivos
    getPracticasYDispositivos: () => fetchConToken(`PracticasyDispositivos`),
    insertPracticasYDispositivos: (data) => fetchConToken(`PracticasyDispositivos`, data, 'POST'),
    updatePracticasYDispositivos: (id, data) => fetchConToken(`PracticasyDispositivos/${id}`, data, 'PUT'),
    removePracticasYDispositivos: (id) => fetchConToken(`PracticasyDispositivos/${id}`, {}, 'DELETE'),

    //Archivos Solicitudes
    getTipoArchivos: () => fetchConToken(`ArchivosSurge/TipoArchivos`),
    getArchivosSolicitudes: (idTipoArchivo, parameters) => fetchConToken(`ArchivosSurge/${idTipoArchivo}${armarParametros(parameters)}`),
    uploadArchivoSolicitud: (file, idTipoArchivo, dispatch) => fetchConTokenFiles(`ArchivosSurge/${idTipoArchivo}`, file, dispatch),

    //Excel
    getExcelSolicitudesSSS: (parameters) => fetchConToken(`SolicitudesSSS/Excel${armarParametros(parameters)}`),
    getPlantillaExcel: (idEstado) => fetchConToken(`ArchivosSurge/PlantillaExcel/${idEstado}`),
};

export default SurgeService; 